import axios from 'axios'

// 'http://192.168.100.96:5356'

const domain = process.env.URL_MEMED

export default axios.create({
  domain,
  baseURL: process.env.URL_MEMED
})



// WEBPACK FOOTER //
// ./src/store/modules/memed/axiosMemed.js